import React from "react";

interface OrgInitialsAvatarProps {
	letter: string;
	size?: number;
}

/**
 * Organization avatar for the sidebar
 * Large letter with squared appearance but no background
 */
export const OrgInitialsAvatar: React.FC<OrgInitialsAvatarProps> = ({
	letter,
	size = 20,
}) => {
	return (
		<div
			className="flex items-center justify-center text-stone-700 font-bold"
			style={{
				width: `${size}px`,
				height: `${size}px`,
				aspectRatio: "1/1",
				position: "relative",
				border: "1px solid rgba(0, 0, 0, 0.05)",
				borderRadius: "2px",
				backgroundColor: "white",
				boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
			}}
		>
			<span
				style={{
					fontSize: `${Math.max(size * 0.9, 16)}px`,
					lineHeight: 1,
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					color: "blue",
				}}
			>
				{letter}
			</span>
		</div>
	);
};
